export const GET_GENERAL_STATISTIC_SUCCESS = "GET_GENERAL_STATISTIC_SUCCESS";

export const GET_YEAR_STATISTIC_SUCCESS = "GET_YEAR_STATISTIC_SUCCESS";